<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
</button>
<h2 modal-title>Helaas!</h2>
<div modal-content>
    <p>Deze dekking is in uw situatie niet mogelijk.</p>
</div>

<div modal-actions alignment="end">
    <a href="#" class="modal__close-bottom link-secondary" (click)="close()">
        <span>Sluit</span>
        <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#cross-closed"></use></svg>
    </a>
</div>
